"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Interpolates between two values using a value
 * @param  {number} start
 * @param  {number} end
 * @param  {number} value
 * @returns {number}
 */
var lerp = exports.lerp = function lerp(start, end, value) {
  return (end - start) * value + start;
};
/**
 * @param  {number} value
 * @returns {number}
 */


var sineLerp = exports.sineLerp = function sineLerp(value) {
  return Math.asin(value * 2 - 1) / pi + 0.5;
};
/**
 * Apply min and max values to a number.
 * @export
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */


var clamp = exports.clamp = function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
};
/**
 * Interpolates between three values quadratic.
 * @param  {number} start
 * @param  {number} control
 * @param  {number} end
 * @param  {number} value
 * @returns {number}
 */


var quad = exports.quad = function quad(start, control, end, value) {
  var subA = lerp(start, control, value);
  var subB = lerp(control, end, value);
  return lerp(subA, subB, value);
};
/**
 * Modulus with negative values wrapped.
 * @param  {number} value
 * @param  {number} length
 * @returns {number}
 */


var modo = exports.modo = function modo(value, length) {
  return (value % length + length) % length;
};
/**
 *
 * @param {number} theta
 * @returns {number}
 */


var cot = exports.cot = function cot(theta) {
  return Math.tan(theta) ? 1 / Math.tan(theta) : 0;
};
/**
 * Get minimum angle.
 * @param  {number} aAngle
 * @param  {number} bAngle
 * @returns {number}
 */


var minAngle = exports.minAngle = function minAngle(aAngle, bAngle) {
  aAngle = modo(aAngle, tau);
  bAngle = modo(bAngle, tau);
  var angle = Math.min(Math.abs(bAngle - aAngle), Math.abs(bAngle - (aAngle - tau)), Math.abs(bAngle - (aAngle + tau)));
  return angle;
};
/**
 * Get relative difference between two angles.
 * @param  {number} aAngle
 * @param  {number} bAngle
 * @returns {number}
 */


var relAngle = exports.relAngle = function relAngle(aAngle, bAngle) {
  aAngle = modo(aAngle, tau);
  bAngle = modo(bAngle, tau);
  var relativeAngle = bAngle - aAngle;
  var relativeAngleAdd = bAngle + tau - aAngle;
  var relativeAngleSub = bAngle - tau - aAngle;
  if (Math.abs(relativeAngleAdd) < Math.abs(relativeAngle)) relativeAngle = relativeAngleAdd;
  if (Math.abs(relativeAngleSub) < Math.abs(relativeAngle)) relativeAngle = relativeAngleSub;
  return relativeAngle;
};
/**
 * finds the closes relative angle 0-Math.tau
 * @param  {number} angle
 * @param  {number} targetAngle
 * @returns {number}
 */


var matchAngle = exports.matchAngle = function matchAngle(angle, targetAngle) {
  angle = modo(angle, tau);
  var relativeAngle = angle - targetAngle;
  var relativeAngleAdd = angle + tau - targetAngle;
  var relativeAngleSub = angle - tau - targetAngle;
  if (Math.abs(relativeAngleAdd) < Math.abs(relativeAngle)) relativeAngle = relativeAngleAdd;
  if (Math.abs(relativeAngleSub) < Math.abs(relativeAngle)) relativeAngle = relativeAngleSub;
  return targetAngle + relativeAngle;
};
/**
 * @param  {} a1
 * @param  {} a2
 */


var angleDifferenceDegrees = exports.angleDifferenceDegrees = function angleDifferenceDegrees(a1, a2) {
  return 180 - Math.abs(Math.abs(a1 - a2) - 180);
};
/**
 *
 * @export
 * @param {(PIXI.ObservablePoint | TileIndex)} p1
 * @param {(PIXI.ObservablePoint | TileIndex)} p2
 * @param {boolean} [squared]
 * @returns
 */


var distance2d = exports.distance2d = function distance2d(p1, p2, squared) {
  var deltaX = Math.abs(p1.x - p2.x);
  var deltaY = Math.abs(p1.y - p2.y);
  var distanceSquared = Math.pow(deltaX, 2) + Math.pow(deltaY, 2);
  return squared ? distanceSquared : Math.sqrt(distanceSquared);
};